import React from 'react';
import { createRoot } from 'react-dom/client';
// import { DashboardControllerProvider } from './context';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { PageLoaderProvider } from './context/pageLoader';
import { TanstackQueryProvider } from './context/TanstackQueryContext';
import { SocketProvider } from './context/SocketContext';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <TanstackQueryProvider>
      <Provider store={store}>
        <PageLoaderProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </PageLoaderProvider>
      </Provider>
    </TanstackQueryProvider>
    {/* <DashboardControllerProvider>
    </DashboardControllerProvider> */}
  </React.StrictMode>
);
